import React from 'react';
import { HeroSection } from './components/HeroSection';
import { ServicesSection } from './components/ServicesSection';
import { TestimonialsSection } from './components/TestimonialsSection';
import { AboutSection } from './components/AboutSection';
import { FooterSection } from './components/FooterSection';
import { useExternalScript } from './hooks/useExternalScript';
const BINOTEL_GETCALL_SRC = 'https://widgets.binotel.com/getcall/widgets/96bnfdxdlw4s3r6lnwoa.js';
export function App() {
  useExternalScript(BINOTEL_GETCALL_SRC);
  return <main className="bg-zinc-950 min-h-screen" data-id="element-0" data-mp="2mnngs5hxqe1t">
      <HeroSection data-id="element-1" data-mp="31b8lu4ydencd" />
      <ServicesSection data-id="element-2" data-mp="31brzh9gzmpkl" />
      <TestimonialsSection data-id="element-3" data-mp="31c1j8fbfw0hu" />
      <AboutSection data-id="element-4" data-mp="2wk0b95lb0vxm" />
      <FooterSection data-id="element-5" data-mp="2wjgq7g0cxrfd" />
    </main>;
}